export const MOBILE_WIDTH_THRESHOLD = 480
export const TABLET_WIDTH_THRESHOLD = 1024

const MOBILE_AGENT_REGEX = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i
const TABLET_AGENT_REGEX =
  /ipad|android|playbook|nexus (?:7|9|10)|sch-i800|xoom|kindle fire|silk|dell streak|galaxy tab|tab|sm-t|gt-p|gt-n|mediapad|iconia|acer a|acer s|lenovo a|lenovo s|thinkpad|asus eee pad|asus pad|transformer|gigaset|sony tablet|vivotab|pendopad|toshiba at|sony sgp|lg-v|lg g pad|shield tablet|hp slate|elitepad|windows nt|surface/i

export default function detectDevice(): { mobile: boolean; tablet: boolean } {
  // Check if window and navigator are defined
  if ('undefined' === typeof window) {
    return { mobile: false, tablet: false }
  }
  // Check touch support
  else if (!window.navigator?.maxTouchPoints) {
    return { mobile: false, tablet: false }
  }
  // Use matchMedia if available
  else if (window.matchMedia) {
    const landscapeMatch = window.matchMedia('(orientation: landscape)')
    const dimensionProperty = landscapeMatch.matches ? 'height' : 'width'
    return {
      mobile: window.matchMedia(`(max-${dimensionProperty}: ${MOBILE_WIDTH_THRESHOLD}px)`).matches,
      tablet: window.matchMedia(
        `(min-${dimensionProperty}: ${
          MOBILE_WIDTH_THRESHOLD + 1
        }px) and (max-${dimensionProperty}: ${TABLET_WIDTH_THRESHOLD}px)`
      ).matches
    }
  }
  // Fallback to visualViewport if available
  else if (window.visualViewport) {
    const visualViewport = window.visualViewport
    const dimension =
      (visualViewport.width < visualViewport.height ? visualViewport.width : visualViewport.height) *
      (visualViewport.scale || 1)
    return {
      mobile: dimension <= MOBILE_WIDTH_THRESHOLD,
      tablet: dimension > MOBILE_WIDTH_THRESHOLD && dimension <= TABLET_WIDTH_THRESHOLD
    }
  }
  // Fallback to window.innerWidth if available
  else if (window.innerWidth) {
    const dimension = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight
    return {
      mobile: dimension <= MOBILE_WIDTH_THRESHOLD,
      tablet: dimension > MOBILE_WIDTH_THRESHOLD && dimension <= TABLET_WIDTH_THRESHOLD
    }
  }
  // Fallback to userAgent check
  else if ('undefined' !== typeof navigator) {
    const userAgent = navigator.userAgent
    return {
      mobile: MOBILE_AGENT_REGEX.test(userAgent),
      tablet: TABLET_AGENT_REGEX.test(userAgent)
    }
  } else {
    return { mobile: false, tablet: false }
  }
}
